<mat-card appearance="outlined" class="template-card">
    <mat-card-content>
        <div [formGroup]="formGroup">
            <div [formArrayName]="formArrayName">
                @for (template of formArray.controls; track template; let i = $index) {
                <hr class="hr-divider" />
                <reusable-merchant-template [formControlName]="i" [showRemove]="formArray.length > 1"
                    (remove)="removeMerchantTemplate(i)">
                </reusable-merchant-template>
                }
            </div>
        </div>
    </mat-card-content>
    <div class="add-fee-button-container">
        <button class="add-fee-button" type="button" (click)="addAnotherMerchantTemplate()">
            Add Another Fee
        </button>
    </div>
</mat-card>